import { ALLOWED_TENANTS } from 'server/shop-config/tenantEnv'
import { TYPE_PDP_SLIDER_TOP } from 'shared/consts/crosssellWidgets'
import {
  AVAILABLE_PRODUCT_TEMPLATES,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'
import { getProductTemplate } from 'shared/utils/productTemplateUtils'
import { isProductAvailable } from 'views/utils/productUtils'
import { shouldRenderLabel } from 'views/utils/redPointsUtils'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import { EXPA_TOP_SLIDER, TENANT_TOP_SLIDER } from './consts'

export const getSliderTopWidgetId = ({
  firstImpressionFlag,
  productTemplate,
  product,
  widgets,
  tenant,
  expa = '',
}: {
  firstImpressionFlag: boolean
  productTemplate: typeof AVAILABLE_PRODUCT_TEMPLATES[number]
  product: { stockStatus?: { status: string } }
  widgets: Record<string, number>
  tenant: typeof ALLOWED_TENANTS[number]
  expa?: string
}) => {
  const shouldRender =
    firstImpressionFlag &&
    productTemplate !== PRODUCT_TEMPLATES.RX &&
    EXPA_TOP_SLIDER.includes(expa) &&
    TENANT_TOP_SLIDER.includes(tenant) &&
    isProductAvailable(product?.stockStatus)

  return shouldRender ? widgets[TYPE_PDP_SLIDER_TOP] : null
}

export const shouldRenderRedPointsBadge = (
  product: Record<string, unknown>
): boolean => {
  const { multiplierRP, flags, redPoints } = product
  // eslint-disable-next-line react-hooks/rules-of-hooks -- TODO This function uses a hook, so is also a hook and should be renamed to `use…`
  const { tenant } = usePublicConfig()

  // If these flags are absent in the response, treat as true
  let { redPointsIsActive, redPointsMultiplierIsValid } = product
  if (
    [redPointsIsActive, redPointsMultiplierIsValid].every(
      v => typeof v === 'undefined'
    )
  ) {
    redPointsIsActive = true
    redPointsMultiplierIsValid = true
  }

  return shouldRenderLabel({
    // @ts-ignore
    productTemplate: getProductTemplate({ tenant, flags }),
    redPointsMultiplierIsValid,
    redPointsIsActive,
    redPoints,
    multiplierRP,
  })
}
